import Header from "@/atomic/atoms/Header";
import { PropsView } from "../Models/finished";
import { Suspense } from "react";
import TicketModal from "@/atomic/organisms/TicketModal";
import Loading from "@/atomic/atoms/Loading";
import Modal from "@/atomic/atoms/Modal";

export default function RechargeFinishedView({
  goBack,
  gotToHome,
  isVisibleModal,
  toggleModal,
  invoice,
  generatePDF,
  isLoading,
  openInvoice,
  error,
  toggleError
}: PropsView) {
  return (
    <div className="relative flex flex-1 flex-col w-full">
      <Header
        title="Pagamento"
        hasLeftButton
        goBack={goBack}
      />
      <main className="z-10 p-2 w-full flex justify-center h-full text-black h-form">
        <article className="h-full flex flex-col justify-between w-[calc(480px)]">
          <div className="flex items-center justify-center w-full flex-col flex-1">
            <img 
              src={"/icon-checked.png"}
              width={80}
              height={80}
              alt="ícone sucesso"
              className="mt-10"
            />
            <h2 className="text-3xl text-black mt-2 text-center">Parabéns!</h2>
            <h3 className="text-base text-center mt-3">Seu pagamento foi realizado.</h3>
          </div>
          <div className="flex items-center flex-col">
            <button onClick={gotToHome} type="button" className="w-full h-[calc(60px)] rounded-lg border bg-transparent border-black text-black font-medium mt-10">Home</button>
            <button onClick={openInvoice} type="button" className="text-black font-medium mt-10 mb-[calc(80px)]">Ver recibo</button>
          </div>
        </article>
      </main>
      {isVisibleModal && <Suspense fallback={null}>
        <TicketModal
          toggleModal={toggleModal}
          invoice={invoice}
          generatePDF={generatePDF}
        />
      </Suspense>}
      {error && <Suspense fallback={null}>
        <Modal
          title="Ops!"
          message="Seu recibo ainda não está disponível. Em alguns instantes você poderá visualizá-lo."
          actionMessage="Verificar novamente"
          action={() => {
            toggleError();
            openInvoice();
          }}
          actionSecondMessage="Ok, entendi"
          actionSecond={toggleError}
        />
      </Suspense>}
      {isLoading &&  <Suspense fallback={null}>
        <Loading />
      </Suspense>}
    </div>
  );
}
